module.exports = __webpack_public_path__ + "static/media/p16.d7e673ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/priceless/p16.jpg
// module id = 365
// module chunks = 0